<template>
  <div class="game-body-wrapper">
    <!-- <ol>
    <li v-for="(value,key) in this.gameData">{{key}} - {{value}}</li>
  </ol> -->
    <!-- <tr-game-control-panel></tr-game-control-panel> -->
    <slot name="body"> </slot>
    <slot name="testButton"> </slot>
  </div>
</template>

<script>
// import TrGameControlPanel from '../UI/TrGameControlPanel/TrGameControlPanel';
export default {
  name: 'tr-game-body',
  props: [],
  components: {
    // TrGameControlPanel
  },
  data: function () {
    return {};
  },
  mounted: function () {
    console.log('Body');
  },
};
</script>

<style lang="scss">
.game-body-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-top: 8%;
  // padding-bottom: 4%;
  height: 100%;
  width: 100%;
}
ol {
  font-size: xx-large;
}
</style>
